// The entrypoint imports this before starting Inertia. Later page imports
// share the same promise after the initial navigation has already completed.
export const initialInertiaNavigationReady = typeof document === 'undefined'
  ? Promise.resolve()
  : new Promise((resolve) => {
    const onNavigate = () => {
      document.removeEventListener('inertia:navigate', onNavigate)
      resolve()
    }
    document.addEventListener('inertia:navigate', onNavigate)
  })
